module.exports = __webpack_public_path__ + "img/kartta-portofhelsinki.89ef0a25.png";